import type { NodeDefinition } from '@shared/types/node-definition';

const definition: NodeDefinition = {
  type: 'langchain-document-loader',
  name: 'LangChain Document Loader',
  description: 'Load and parse documents from various sources for processing',
  icon: 'FileText',
  color: 'purple',
  category: 'ai-nodes',
  tags: ['langchain', 'document', 'loader', 'text', 'parse'],
  comingSoon: true,
  version: '1.0.0',
  inputs: [],
  outputs: [],
};

export default definition;
